import { defineNuxtPlugin } from "nuxt/app";

export default defineNuxtPlugin({
  name: "ckweb:user",
  enforce: "pre",
  dependsOn: ["ckweb:auth", "ckweb:dev-console"],
  async setup($nuxt) {
    const { refreshCurrentUser } = useAuthApi();
    const organizationStore = useOrganizationStore();

    $nuxt.$auth.addEventCallback(async (event) => {
      switch (event.type) {
        case "auth-login-success": {
          devConsole.info("🔒 ckAuth: loading user");
          await refreshCurrentUser();
          await organizationStore.refreshCurrentOrganization();

          break;
        }
      }
    });

    $nuxt.hook("ckauth:logout", () => {
      devConsole.log("🔔  ckauth:logout hook triggered");
      organizationStore.refreshCurrentOrganization();
    });

    devConsole.info("🛠️ ckSetup: user hooked  🚀🚀🚀🚀🚀");
  },
});
